import queryString from 'query-string'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { close_role_modal, set_role_modal } from '../../action/modals'
import { roles } from '../../constants/constants'
import OutsideAlerter from '../../utils/OutsideAlerter'
import { trans } from '../../utils/utilsTrans'
import InvitingModal from '../User/InvitingModal'

const AdminAbstract = ({
  children,
  roleSelect,
  close_role_modal,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const query = queryString.parse(location.search)
  const [isInvitingModalOpen, setIsInvitingModalOpen] = useState(
    !!query.isInviting
  )

  useEffect(() => {
    if (query.isInviting) setIsInvitingModalOpen(true)
    else setIsInvitingModalOpen(false)
  }, [location.key])

  const closeInvitingModal = () => {
    setIsInvitingModalOpen(false)
    navigate(location.pathname, { replace: true })
  }

  return (
    <div>
      {isInvitingModalOpen ? (
        <InvitingModal
          onClose={closeInvitingModal}
          userEmail={query.invitedUser}
          isAdmin={query.admin}
          company={query.company}
        />
      ) : null}
      {roleSelect ? (
        <div
          className='z-50 absolute bg-white border border-greyLight7 rounded-8 mt-8 shadow-md'
          style={{
            left: `${roleSelect.position[0]}px`,
            top: `${roleSelect.position[1] + 44}px`,
          }}
        >
          <OutsideAlerter
            onClickOutside={close_role_modal}
            className='w-[276px] flex flex-col'
          >
            {roles.map((v, k) => {
              if (!roleSelect?.blackListRoles.includes(v.id))
                return (
                  <button
                    type='button'
                    key={`role_${v.id}`}
                    onClick={() => {
                      roleSelect.onSelect(v.id)
                    }}
                    className={
                      'py-10 px-16 flex flex-col space-y-2 text-left transition-colors first:rounded-t-8 ' +
                      (roleSelect.current === v.id
                        ? 'bg-primaryLight3 text-primary'
                        : 'hover:bg-backgroundSecondary text-greyLight1') +
                      (!roleSelect.hasDelete ? ' last:rounded-b-8' : '')
                    }
                  >
                    <span className='block text-sm font-semibold'>
                      {trans(`users.roles.${v.id}.name`)}
                    </span>
                    <span className='block whitespace-normal text-[13px] text-greyLight4 font-medium'>
                      {trans(`users.roles.${v.id}.desc`)}
                    </span>
                  </button>
                )
            })}
            {roleSelect.hasDelete ? (
              <>
                <div className='h-[1px] w-full bg-greyLight7' />
                <button
                  type='button'
                  onClick={() => {
                    roleSelect.onDelete()
                  }}
                  className='p-16 text-left text-sm font-medium text-error hover:bg-backgroundError transition-colors rounded-b-8'
                >
                  {trans('users.delete')}
                </button>
              </>
            ) : null}
          </OutsideAlerter>
        </div>
      ) : null}
      {children}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ set_role_modal, close_role_modal }, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    roleSelect: state.modals.roleSelect,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAbstract)
